import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import api from '../api';
import { getToken, setAuth, isCompanyAdmin } from '../authStorage';

/**
 * Đồng bộ /auth/me trước khi vẽ Navbar + trang — tránh một nhịp coi nhầm quyền
 * (Tiến độ thiếu «Tất cả đội», menu sai trạng thái).
 */
const Layout = ({ children }) => {
  const [authReady, setAuthReady] = useState(() => !getToken());
  /** Giao diện tối — đồng bộ sau /auth/me + localStorage để không lệch một nhịp */
  const [themeAdmin, setThemeAdmin] = useState(false);

  useEffect(() => {
    const tok = getToken();
    if (!tok) {
      setAuthReady(true);
      setThemeAdmin(false);
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        const me = await api.get('/auth/me');
        if (!cancelled && me.data?.user && tok) {
          setAuth({ token: tok, user: me.data.user, teams: me.data.teams || [] });
        }
      } catch {
        /* ignore */
      } finally {
        if (!cancelled) {
          setAuthReady(true);
          /* setAuth đồng bộ; đọc lại quyền sau khi đã ghi localStorage */
          setThemeAdmin(isCompanyAdmin());
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!authReady) return undefined;
    document.documentElement.classList.toggle('theme-admin', themeAdmin);
    document.body.classList.toggle('theme-admin', themeAdmin);
    return () => {
      document.documentElement.classList.remove('theme-admin');
      document.body.classList.remove('theme-admin');
    };
  }, [authReady, themeAdmin]);

  if (!authReady) {
    return (
      <div className="app-loading">
        <p>Đang tải…</p>
      </div>
    );
  }

  return (
    <div className={themeAdmin ? 'app-shell app-shell--admin' : 'app-shell'}>
      <Navbar adminTheme={themeAdmin} />
      <main className="layout-main">{children}</main>
    </div>
  );
};

export default Layout;
